import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { InvitationsTool } from "@/features/marketing/tools/invitations-tool";

export const Route = createFileRoute("/_marketing/$lang/when-to-send-wedding-invitations")({
  head: SEO.invitations,
  component: InvitationsTool,
});
